// extracted by mini-css-extract-plugin
export var externalLink = "_69-0";
export var internalLinkLabel = "_69-1";